<template>
  <div>
    <section class="page-header-section">
      <div class="circle-pattern-3">
        <img src="/assets/images/banner/circle-pattern-3.svg" width="200" alt="" />
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-lg-7">
            <!---->
            <h2 class="heading">AI Mentor</h2>
            <span class="desc d-block">Provides personalized, real-time help to student by answering questions and guiding them through educational content. Enhances understanding and engagement through adaptive support based on individual learning needs.</span>
          </div>
        </div>
      </div>
    </section>

    <section class="aiTutorWrap">
      <div v-if="loading" class="loading-state">
        <div class="d-flex justify-content-center align-items-center" style="min-height: 100px">
          <div class="text-center w-5 h-5">
            <span class="spinner-border"></span>
          </div>
        </div>
      </div>
      <div v-else class="container">
        <div class="gradeBtnWrap">
          <button v-for="item in classes" v-bind:key="item.id" v-on:click="selectClass(item)" :class="{ active: item.id == selectedClass.id }">
            {{ item.displayName }}
          </button>
        </div>
        <div class="boardBtnWrap">
          <button v-for="item in selectedClass.children" v-bind:key="item.id" v-on:click="selectBoard(item)" :class="{ active: item.id == selectedBorad.id }">
            <img v-show="item.image" :src="item.image" width="100" height="100" alt="" />
            {{ item.displayName }}
          </button>
        </div>
        <div class="subjectBtnWrap">
          <button v-for="item in selectedBorad.children" v-bind:key="item.id" v-on:click="selectSubject(item)" :class="[selectedSubject != null && selectedSubject.id == item.id ? 'active' : '', item.disabled ? 'disabled' : '']" :disabled="item.disabled">
            {{ item.displayName }}
          </button>
        </div>
      </div>
    </section>
    <div v-if="showBot">
      <AiTutorBot :agentId="selectedSubject.chatGroupId" :chatTitle="selectedSubject.displayName" />
    </div>
    <appFooter />
  </div>
</template>

<script>
import SsrCarousel from "vue-ssr-carousel";
import "vue-ssr-carousel/index.css";
import pageHeader from "../../components/pageHeader";
import appFooter from "../../layout/landing/appFooter.vue";
import AiTutorBot from "../../components/AiTutorBot.vue";
import axios from "axios";
export default {
  components: {
    SsrCarousel,
    pageHeader,
    appFooter,
    AiTutorBot,
  },

  metaInfo: {
    title: "Ai Mentor | KIPS VIRTUAL",
    titleTemplate: "",
    htmlAttrs: {
      lang: "en",
      amp: true,
    },
  },

  data() {
    return {
      classes: [],
      selectedClass: null,
      selectedBorad: null,
      selectedSubject: null,
      showBot: false,
      loading: true,
    };
  },

  methods: {
    selectOnLoad() {
      this.selectedClass = this.classes[0];
      let findNode = this.classes.find((node) => node.id == this.selectedClass.id);
      this.selectedBorad = findNode.children.length > 0 ? findNode.children[0] : [];
    },
    selectClass(selectedItem) {
      this.selectedClass = selectedItem;
      this.selectedBorad = selectedItem.children.length > 0 ? selectedItem.children[0] : [];
      this.selectedSubject = null;
      this.showBot = false;
    },
    selectBoard(selectedItem) {
      this.selectedBorad = selectedItem;
      this.selectedSubject = null;
      this.showBot = false;
    },
    selectSubject(selectedItem) {
      this.selectedSubject = selectedItem;
      this.showBot = true;
    },
  },

  async mounted() {
    document.body.classList.add("removeChatIcons");
    try {
      const response = await axios.get("/assets/classes/index.json");
      this.classes = response.data;
      this.selectOnLoad();
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
    window.scrollTo(0, 0);
  },
  beforeDestroy() {
    document.body.classList.remove("removeChatIcons");
  },
};
</script>
